<template>
  <transition name="modal-fade">
    <div v-if="show" class="modal-overlay" @click.self="handleClose">
      <div class="modal-container">
        <!-- 模态框头部 -->
        <div class="modal-header">
          <h3 class="modal-title">{{ announcement.title }}</h3>
          <button @click="handleClose" class="close-button">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <!-- 模态框内容 -->
        <div class="modal-content">
          <div class="announcement-content" v-html="announcement.content"></div>
        </div>

        <!-- 模态框底部 -->
        <div class="modal-footer">
          <button @click="handleClose" class="close-button-primary">
            我知道了
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import announcementService from '../services/announcementService'

export default {
  name: 'AnnouncementModal',
  props: {
    announcement: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        // 记录展示
        announcementService.recordDisplay(this.announcement.id)
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-container {
  background: white;
  border-radius: 12px;
  max-width: 500px;
  width: 100%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 0;
  margin-bottom: 16px;
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
}

.close-button:hover {
  color: #374151;
  background-color: #f3f4f6;
}

.modal-content {
  flex: 1;
  padding: 0 24px;
  overflow-y: auto;
}

.announcement-content {
  line-height: 1.6;
  color: #4b5563;
  margin-bottom: 20px;
}

/* 富文本内容样式 */
.announcement-content >>> p {
  margin: 0 0 10px 0;
}

.announcement-content >>> a {
  color: #3b82f6;
  text-decoration: underline;
}

.announcement-content >>> a:hover {
  color: #2563eb;
}

.announcement-content >>> img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 10px 0;
}

.announcement-content >>> ul,
.announcement-content >>> ol {
  padding-left: 20px;
  margin: 10px 0;
}

.announcement-content >>> li {
  margin: 5px 0;
}

.announcement-content >>> blockquote {
  border-left: 4px solid #e5e7eb;
  padding-left: 16px;
  margin: 10px 0;
  color: #6b7280;
}

.announcement-content >>> strong {
  font-weight: 600;
}

.announcement-content >>> em {
  font-style: italic;
}

.announcement-content >>> h1,
.announcement-content >>> h2,
.announcement-content >>> h3,
.announcement-content >>> h4 {
  margin: 16px 0 8px 0;
  font-weight: 600;
  color: #1f2937;
}

.announcement-content >>> h1 {
  font-size: 1.5em;
}

.announcement-content >>> h2 {
  font-size: 1.3em;
}

.announcement-content >>> h3 {
  font-size: 1.1em;
}

.announcement-content >>> table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
}

.announcement-content >>> table td,
.announcement-content >>> table th {
  border: 1px solid #e5e7eb;
  padding: 8px;
}

.announcement-content >>> table th {
  background-color: #f9fafb;
}

.modal-footer {
  display: flex;
  justify-content: center;
  padding: 16px 24px 20px;
  border-top: 1px solid #e5e7eb;
  background-color: #fafafa;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.close-button-primary {
  background-color: #3b82f6;
  border: none;
  color: white;
  padding: 8px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.close-button-primary:hover {
  background-color: #2563eb;
}

/* 动画效果 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: transform 0.3s ease;
}

.modal-fade-enter-from .modal-container {
  transform: scale(0.9);
}

.modal-fade-leave-to .modal-container {
  transform: scale(0.9);
}

/* 响应式设计 */
@media (max-width: 640px) {
  .modal-overlay {
    padding: 10px;
  }
  
  .modal-container {
    max-width: 100%;
    max-height: 90vh;
  }
  
  .modal-header,
  .modal-content {
    padding: 16px;
  }
  
  .modal-footer {
    padding: 12px 16px 16px;
  }
}
</style>